export function isApiMocksEnabled(): boolean {
  return process.env.NEXT_PUBLIC_API_MOCKS === 'true'
}

export function isE2EObservabilityDisabled(): boolean {
  return isApiMocksEnabled()
}
